import { ToastrService } from 'ngx-toastr';

import { GraphqlService } from 'src/app/graphql/graphql.service';
import { UserAuditService } from 'src/app/user-audit/user-audit.service';
import { ServiceLocator } from '../../service-locator.service';
import { Attachment } from '../attachment';
import { CommissionType } from '../commission-type';
import { PendingCommission } from '../pending-commission';
import { SupplierCommissionAttachmentSheet } from '../supplier-commission-attachment-sheet';
import { SupplierCommissionMap } from '../supplier-commission-map';
import { ViewCommissionReport } from '../view-commission-report';

export abstract class AbstractPreviewReport {
	//Shared variables
	public totalSupplierPayment = 0;
	public pendingCommissions: PendingCommission[] = [];
	public rawData: any[] = [];
	public loading = false;

	//Mapping preview variables
	public sheet: SupplierCommissionAttachmentSheet;
	public report: ViewCommissionReport;
	public supplierCommissionMaps: SupplierCommissionMap[];
	public commissionTypes: CommissionType[];
	public attachment: Attachment;

	public abstract canEditSheetMapping: boolean;
	public abstract suffixLabel: string;

	protected toastrService: ToastrService;
	protected graphqlService: GraphqlService;
	protected userAuditService: UserAuditService;

	constructor() {
		this.toastrService = ServiceLocator.injector.get(ToastrService);
		this.graphqlService = ServiceLocator.injector.get(GraphqlService);
		this.userAuditService = ServiceLocator.injector.get(UserAuditService);
	}

	public abstract setup(): Promise<void>;
	public abstract getRawData(): Promise<any[]>;
	public abstract getMappedData(): Promise<PendingCommission[]>;
	public abstract updateSheetMapping(supplierCommissionMapId: number): Promise<void>;
	public abstract applySystemGeneratedMapping(): Promise<boolean>;
}
